import React, { useEffect, useState } from "react";
import { useMediaQuery, useTheme } from "@mui/material";
import SettingsMain from "./SettingsMain";
import PageLayout from "../../components/PageLayout";

const Settings = () => {
  const theme = useTheme();
  const mdScreen = useMediaQuery(theme.breakpoints.down("md"));

  const [collapse, setCollapse] = useState(false);

  useEffect(() => {
    setCollapse(mdScreen);
  }, [mdScreen]);

  return (
    <PageLayout title="Profile Settings">
      <SettingsMain collapse={collapse} />
    </PageLayout>
  );
};

export default Settings;
